import type { Polygon } from 'geojson'
import apiClient from '@app/config/axios.config'
import type { DrawArea, MapLayer } from '@app/types/layerTypes'
import type { RegionOption } from '@app/components/Molecules/RegionFilter'
import type { IdentifyingInformationFilter } from '@app/types/filterTypes'
import type { AssetHazardInstance } from '@app/components/Molecules/MapView/RiskMapView/RiskMapView'

interface GetVulnerabilityStatsProps {
  assetLayer: MapLayer
  hazardLayer: MapLayer
  regionMasks: RegionOption[] | null
  drawAreas: DrawArea[]
  elementFilters: IdentifyingInformationFilter
  cascadingAssetNDays: Record<string, number | null>
}

type VulnerabilityStatsByAssetId = Record<string, AssetHazardInstance>

export async function getVulnerabilityStats({
  assetLayer,
  hazardLayer,
  regionMasks,
  drawAreas,
  cascadingAssetNDays,
}: GetVulnerabilityStatsProps): Promise<VulnerabilityStatsByAssetId> {
  const regions = regionMasks?.map((region) => region.region).join(',') ?? ''

  const drawArea = drawAreas.length > 0 ? (drawAreas[0].geometry as Polygon) : null

  const drawAreaCsv = drawArea ? drawArea.coordinates[0].flat().join(',') : ''

  const nDays = cascadingAssetNDays[assetLayer.type] ?? 0

  const params = new URLSearchParams({
    regions,
  })

  if (assetLayer.is_cascading) {
    params.set('n_days', nDays.toString())
  }

  const response = await apiClient.get(
    `/asset/risk/${assetLayer.type}/${hazardLayer.assetTag}/${drawAreaCsv}?${params.toString()}`,
  )

  return response.data
}
